export default "__VITE_ASSET__DnF4aXpH__"